import { api } from './client';

export interface AuditLogRow {
  id: string;
  actorId: number | null;
  actorName: string | null;
  entityType: string;
  entityId: number;
  action: string;
  beforeJson: string | null;
  afterJson: string | null;
  ip: string | null;
  /** Resolved document reference for the record, e.g. "DO-2026-173" (null if not resolvable). */
  ref: string | null;
  at: string;
}

export interface AuditListResponse {
  rows: AuditLogRow[];
  total: number;
  page: number;
  pageSize: number;
}

export interface AuditFilter {
  search?: string;
  action?: string;
  entityType?: string;
  from?: string;
  to?: string;
  page?: number;
  pageSize?: number;
}

export async function listAuditLogs(params: AuditFilter = {}) {
  return (await api.get<AuditListResponse>('/audit', { params })).data;
}

export async function getAuditFacets() {
  return (await api.get<{ actions: string[]; entityTypes: string[] }>('/audit/facets')).data;
}
